import React, { Component } from "react";
import "../../styles/legal_terms/legal_terms.css";

class CookiePolicy extends Component {
  render() {
    return (
        <div className="legal-terms-container">
            <article>
                <h1>Política de cookies</h1>
                <p>
                    Nuestro sitio web utiliza cookies para mejorar su experiencia de navegación y proporcionar funcionalidades adicionales. Las cookies son pequeños archivos de texto que se almacenan en su dispositivo cuando visita un sitio web.
                    Utilizamos cookies para analizar el tráfico del sitio, personalizar el contenido y los anuncios, proporcionar funciones de redes sociales y mejorar la funcionalidad del sitio. También podemos compartir información sobre su uso del sitio web con nuestros socios de redes sociales, publicidad y análisis.
                    Al utilizar nuestro sitio web, usted acepta el uso de cookies de acuerdo con esta política. Puede controlar y gestionar las cookies en la configuración de su navegador. Sin embargo, deshabilitar ciertas cookies puede afectar la funcionalidad y la experiencia de navegación en nuestro sitio web.
                    Para obtener más información sobre cómo utilizamos las cookies y cómo puede optar por no recibirlas, consulte nuestra política de cookies completa disponible en nuestro sitio web.
                    <br/>
                    Gracias por visitar NOI Donostia.
                </p>
            </article>
        </div>
      );
  }
}

export default CookiePolicy;